import React, { useState, useEffect } from "react";
import SchoolHeader from "../../SchoolHeader";
import Footer from "../../Footer";
import HospitalHeader from "../../HospitalHeader";
import { Container, Card, Row, Col, Modal, Button, Form } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { MultiSelect } from "react-multi-select-component";
import hospitalServices from "../../../services/hospital.services";
import { RotationReqSchool } from "./RotaionReqFiles";
import LoadingBar from "../toaster/loader/loader";
import { toast } from "react-toastify";
import { showSuccessMessage, showErrorMessage } from "../../../services/utils";
import { RotationProgramsAccToSchl } from "./RotationProgramsAccToSchl";
import { authServices } from "../../../services/auth.services";

const ProgramDetails = ({ id,access }) => {

    const role = localStorage.getItem("PageTittle")
    const is_auth_sub_admin = JSON.parse(localStorage.getItem("type"))
    const params = useParams()
    const [show, setShow] = useState(false)
    const [loadin, Setloading] = useState(false)
    const [subProgram, setSubProgram] = useState(false)
    const [sub_admin, setSub_admin] = useState({
        program: [], programShow: []
    })
    const [rotationReqList, setRotationReqList] = useState()
    const [optionList, setoptionList] = useState([])
    const [select, setSelected] = useState({
        subAdmin: [],
    })
    const [selectedProgram, setSelectedProgram] = useState([])

    const getRotationReq = (data) => {
        setRotationReqList("")
        Setloading(true)
        hospitalServices.getRotationProgramsAccToSchl(data)
            .then((res) => {
                Setloading(false)

                setRotationReqList(res.data.data)
            })
            .catch((err) => {
                Setloading(false)
                showErrorMessage({ message: err.response.data.errors.msg })
            }
            )
    }
    // _________________________________ for getprogram

    const getRotationProgramsAccToSchl = (data, sub_admin_id) => {
        Setloading(true)

        hospitalServices.getRotationProgramsAccToSchl(data, sub_admin_id)
            .then(resp => {
                resp.data.data && resp.data.data.length > 0 ?

                    resp.data.data.map(curr => {
                        setSelectedProgram(prevState => ([...prevState,
                        {
                            label: curr.programInfo.program_name,
                            value: curr.program_id

                        }]))
                    }) : setSelectedProgram(resp.data.data)
                setSubProgram(true)
                Setloading(false)

            })

    }


    function handleClose() {
        setShow(false)
    }

    const getHospitalSubAdmins = () => {
        const user = JSON.parse(localStorage.getItem("user"))
        authServices.getSubAdminList(user.user_id, "is_auth_sub_admin").then(resp => {
            resp.user && resp.user.length > 0 &&
                setoptionList(resp.user)

        })
    }
    // __________________________give pervillage api hit on model_________________________________13/feb/2023

    const privillegePermission = (data) => {
        const body = {
            "sub_admin_id": select.subAdmin,
            "school_id": params.school_id,
            "program_ids": sub_admin.program
        }

        hospitalServices.giveSubadminProgramPrivillege(body)

            .then((res) => {
                setRotationReqList(res.data.data)
                setShow(false)
                toast.success("permission applied Successfully")

            })
            .catch((err) =>
                showErrorMessage({ message: err.response.data.errors.msg })
            )
    }


    useEffect(() => {
        getRotationReq(params.school_id);
        getHospitalSubAdmins();
    }, [])


    return (
        <div className="dashbrd_pg">
            {role === "School" ?
                <SchoolHeader />
                :
                <HospitalHeader />
            }

            <div className="schl_prfl_pg">
                <Container className="custm_container">
                    {loadin &&
                        <LoadingBar />
                    }
                    <div className="prfl_wrap">
                        <Row>
                            <Col sm={12}>
                                <Card className="pg_card">
                                    <Card.Body>
                                        <div className="apprvl_list">
                                            <div
                                                style={{
                                                    height: 400,
                                                    width: "100%",
                                                }}
                                            >
                                                <Card.Body>
                                                    <div className="card_hdng">
                                                        <h4 className="mb-0">
                                                            Type of Programs
                                                        </h4>
                                                        {!is_auth_sub_admin&&<Button onClick={() => setShow(true)}>
                                                            Set Privilleges
                                                        </Button>}
                                                    </div>

                                                    <RotationProgramsAccToSchl shardFiles={rotationReqList} />

                                                </Card.Body>

                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Modal show={show} onHide={handleClose} className="main_modl">
                            <Modal.Header closeButton>
                                <Modal.Title className="text_theme">
                                    Send A Message
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <Form className="mb-3">
                                    <Form.Select aria-label="Default select example"
                                        name="program_id"
                                        value={select.subAdmin}
                                        onChange={(e) => {

                                            setSelected(prev => ({ ...prev, "subAdmin": e.target.value }))
                                            getRotationProgramsAccToSchl(params.school_id, e.target.value)


                                        }}
                                        required
                                    >
                                        <option>Select SubAdmin</option>
                                        {optionList.map(curr => {
                                            return (
                                                <option key={curr._id} value={curr._id}>{curr.name}</option>
                                            )
                                        })}
                                    </Form.Select>
                                </Form>
                                {subProgram &&

                                    <>
                                        <MultiSelect
                                            overrideStrings={{
                                                "allItemsAreSelected": "All Schools are selected.",
                                                "noOptions": "No Schools available",
                                                "search": "Search for Schools",
                                                "clearSearch": "Clear Search",
                                                "clearSelected": "Clear Selected",
                                                "selectAll": "Select All Schools",
                                                "selectAllFiltered": "Select All (Filtered)",
                                                "selectSomeItems": "Select programs you want share",
                                                "create": "Create",
                                            }}
                                            className="multi_slct"
                                            options={selectedProgram}
                                            value={sub_admin.programShow}
                                            onChange={(e) => {
                                                setSub_admin(prev => ({ ...prev, "programShow": e }))
                                                e.length > 0 ?
                                                    e.map(resp => {
                                                        setSub_admin(prev => ({ ...prev, "program": [...prev.program, resp.value] }))
                                                    }) :
                                                    setSub_admin(prev => ({ ...prev, "program": [] }))
                                            }}
                                            labelledBy="Select"
                                        />
                                        <p> *Note=As soon as you shared the programme, it was removed from the drop-down list.</p>
                                        <div className="d-flex justify-content-center mt-3">

                                            <Button onClick={() => privillegePermission()} disabled={!sub_admin.program.length > 0 && "true"}>
                                                Give Permission
                                            </Button>
                                        </div>
                                    </>
                                }

                            </Modal.Body>
                        </Modal>
                    </div>
                </Container>
            </div>
            <Footer />
        </div>
    );
};

export default ProgramDetails;
